import { render, staticRenderFns } from "./ModuleListItem.vue?vue&type=template&id=29740717&scoped=true&"
import script from "./ModuleListItem.vue?vue&type=script&lang=js&"
export * from "./ModuleListItem.vue?vue&type=script&lang=js&"
import style0 from "./ModuleListItem.vue?vue&type=style&index=0&id=29740717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29740717",
  null
  
)

export default component.exports